import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Validate that required Firebase config values are present
const isConfigValid = firebaseConfig.apiKey && 
                      firebaseConfig.authDomain && 
                      firebaseConfig.projectId &&
                      firebaseConfig.apiKey !== 'undefined' &&
                      firebaseConfig.authDomain !== 'undefined' &&
                      firebaseConfig.projectId !== 'undefined';

if (!isConfigValid) {
  console.error("Firebase configuration is incomplete. Please check your environment variables.");
  console.error("Config values:", {
    apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'MISSING',
    authDomain: firebaseConfig.authDomain || 'MISSING',
    projectId: firebaseConfig.projectId || 'MISSING'
  });
}

// Initialize Firebase
let app = null;
let firebaseInitialized = false;

if (isConfigValid) {
  try {
    app = initializeApp(firebaseConfig);
    firebaseInitialized = true;
  } catch (error) {
    console.error("Failed to initialize Firebase:", error);
    // Don't throw - let the app handle this gracefully
  }
} else {
  console.error("Skipping Firebase initialization due to invalid configuration");
}

// Initialize analytics only if config is valid and app is initialized
// This prevents the app from crashing if analytics can't be initialized
let analytics = null;
if (app && firebaseInitialized) {
  try {
    // Only initialize analytics if we have a measurement ID and we're in a browser environment
    if (firebaseConfig.measurementId && typeof window !== 'undefined') {
      analytics = getAnalytics(app);
    }
  } catch (error) {
    console.warn("Firebase Analytics initialization failed:", error);
    // Continue without analytics - the app should still work
  }
}

// Only initialize Firebase services if app was successfully initialized
let auth = null;
let db = null;
let functions = null;

if (app && firebaseInitialized) {
  try {
    auth = getAuth(app);
    db = getFirestore(app);
    functions = getFunctions(app, "europe-west1");
  } catch (error) {
    console.error("Failed to initialize Firebase services:", error);
  }
}

export { auth, db, analytics, functions, firebaseInitialized };
